import { createFileRoute } from "@tanstack/react-router";
import { KundestøttePage } from "@/features/landing/KundestøttePage";

export const Route = createFileRoute("/_landing/kundestøtte")({
  component: KundestøttePage,
  head: () => ({
    meta: [
      {
        title: "Kundestøtte | Norgespris for Fjernvarme",
      },
    ],
  }),
});
